// Shared helpers for the dispatcher app shell (DispatcherLayout + its pages).
// Same conventions DispatcherBoard.jsx already uses (token in localStorage,
// bearer auth header) -- kept here instead of duplicated per-page.
export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

export function authHeaders() {
  const token = localStorage.getItem("token");
  return { headers: { Authorization: `Bearer ${token}` } };
}

// Same convention DispatcherBoard.jsx already established for its own
// admin-only features -- roles are stamped into localStorage at login,
// not re-fetched per page.
export function isAdmin() {
  const roles = JSON.parse(localStorage.getItem("roles") || "[]");
  return roles.includes("admin") || roles.includes("super_admin");
}

// Stricter than isAdmin() -- for surfaces a plain per-tenant admin
// shouldn't see, like the hard spend-ceiling controls in
// FleetCostSettings.jsx. Mirrors auth.require_super_admin's server-side
// gate; this check is the UI convenience, not the real enforcement.
export function isSuperAdmin() {
  const roles = JSON.parse(localStorage.getItem("roles") || "[]");
  return roles.includes("super_admin");
}

// Backend timestamps are naive UTC (no 'Z'/offset). new Date() would parse
// them as LOCAL time, skewing "x ago"/clocks by the viewer's UTC offset.
// Append 'Z' when there's no timezone so they're read as UTC.
export function toUtcDate(iso) {
  if (!iso) return null;
  const s = /[zZ]$|[+-]\d\d:?\d\d$/.test(iso) ? iso : iso + "Z";
  return new Date(s);
}

// Same helper DispatcherBoard.jsx already has locally -- "23.7h" reads
// like a stopwatch, not a shift length. "23h 42m" is what a dispatcher
// actually thinks in.
export function formatHm(hours) {
  const totalMinutes = Math.round((hours || 0) * 60);
  if (totalMinutes < 60) return `${totalMinutes}m`;
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
}
